import { ReactNode } from 'react'
import styled from 'styled-components'

import { Stylable } from 'utils/types'

interface Props extends Stylable {
  children: ReactNode
  variant?: 'warning' | 'error' | 'success'
}

const Container = styled.div<{ $variant: 'warning' | 'error' | 'success' }>`
  height: 56px;
  width: 100%;
  background-color: ${p =>
    p.$variant === 'error'
      ? p.theme.colors.alerts.error.background
      : p.$variant === 'success'
        ? p.theme.colors.alerts.success.background
        : p.theme.colors.alerts.warning.background};
  border: 1px solid
    ${p =>
      p.$variant === 'error'
        ? p.theme.colors.alerts.error.border
        : p.$variant === 'success'
          ? p.theme.colors.alerts.success.border
          : p.theme.colors.alerts.warning.border};
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${p =>
    p.$variant === 'error'
      ? p.theme.colors.alerts.error.color
      : p.$variant === 'success'
        ? p.theme.colors.alerts.success.color
        : p.theme.colors.alerts.warning.color};
  & > div {
    padding: 0 16px;
    color: ${p =>
      p.$variant === 'error'
        ? p.theme.colors.alerts.error.color
        : p.$variant === 'success'
          ? p.theme.colors.alerts.success.color
          : p.theme.colors.alerts.warning.color};
  }
  a {
    color: ${p =>
      p.$variant === 'error'
        ? p.theme.colors.alerts.error.color
        : p.$variant === 'success'
          ? p.theme.colors.alerts.success.color
          : p.theme.colors.alerts.warning.color};
  }
  border-radius: 8px;
`

export const Banner = ({ children, style, className, variant = 'warning' }: Props) => {
  return (
    <Container style={style} className={className} $variant={variant}>
      {children}
    </Container>
  )
}
